import { usePatchState } from '@/shared/hooks';
import type { InviteResolution } from '../api/captureApi';
import { usePrivateFeedbackSubmit } from '../hooks/usePrivateFeedbackSubmit';
import { CapturePrivateScreen } from './CapturePrivateScreen';

interface FlowState {
  privateFeedback: string;
  patientName: string;
  patientContact: string;
  privateSending: boolean;
  privateDone: boolean;
}

// Below 5 stars: private feedback and the public Google review are offered
// together on one screen (see CapturePrivateScreen) rather than as a forced
// sequence — a compliance-motivated change, not just a UX one.
export function CaptureLowRatingFlow({
  resolution,
  shortCode,
  rating,
  onBackToIntro,
}: {
  resolution: InviteResolution;
  shortCode: string;
  rating: number | null;
  onBackToIntro: () => void;
}) {
  const [state, set] = usePatchState<FlowState>({
    privateFeedback: '',
    patientName: '',
    patientContact: '',
    privateSending: false,
    privateDone: false,
  });

  const handleSubmitPrivate = usePrivateFeedbackSubmit(shortCode, rating, state, set);

  return (
    <CapturePrivateScreen
      feedback={state.privateFeedback}
      onChangeFeedback={(v) => set({ privateFeedback: v })}
      patientName={state.patientName}
      onChangePatientName={(v) => set({ patientName: v })}
      patientContact={state.patientContact}
      onChangePatientContact={(v) => set({ patientContact: v })}
      sending={state.privateSending}
      done={state.privateDone}
      onSubmit={handleSubmitPrivate}
      onBack={onBackToIntro}
      resolution={resolution}
      shortCode={shortCode}
      rating={rating}
    />
  );
}
